import React from "react";
import { Card, CardBody, Col, Media } from "reactstrap";
import styles from "./greetingcard.module.scss";

import CarToon from "../../../assets/images/dashboard/cartoon.svg";
import Clock from "../../../assets/images/clock.svg";
import Button from "../../Shared/Button";

const GreetingCard = () => {
  return (
    <Col className={styles["column"]}>
      <Card className={styles["profile_card"]}>
        <CardBody className={styles["card_body"]}>
          <Media>
            <Media body>
              <div className={styles["greeting-user"]}>
                <div>
                  <h4 className={styles["heading_text"]}>Welcome to LumiRX</h4>
                  <p className={styles["sub_text"]}>
                    Here whats happening in your account today
                  </p>
                  <button className={styles["whatsnew_button"]}>
                    Whats New !
                  </button>
                </div>

                <div className={styles["cartoon_right_container"]}>
                  <img src={CarToon} alt="vector" />
                </div>
              </div>
            </Media>
            {/* <div className={styles["clockbox"]}>
              <img src={Clock} alt="clock" width={45} height={45} />
            </div> */}
          </Media>
          {/* <div className={styles["cartoon_container"]}>
            <img src={CarToon} alt="vector" width={197} height={174} />
          </div> */}
        </CardBody>
      </Card>
    </Col>
  );
};

export default GreetingCard;
